import { Stack } from '@mui/material';

import { OverlayContent } from './OverlayContent';
import { Button } from '../../buttons';
import { HexIcon } from '../../hex-icons';
import * as Icons from '../../icons';
import { useDrawerOverlay } from '../DrawerOverlayProvider';
import { useDrawerInstance } from '../hooks';

type Props = {
  onLeave?: () => void;
  onContinue?: () => void;
  title?: string;
  body?: string;
  continueLabel?: string;
};

export const ExitConfirmationOverlay = ({
  onLeave,
  onContinue,
  title = 'Are you sure you want to leave without saving?',
  body = 'Any unsaved changes will be lost.',
  continueLabel = 'Continue editing',
}: Props) => {
  const { close } = useDrawerInstance();
  const { destroyOverlay } = useDrawerOverlay();
  const { setShouldRenderGuard } = useDrawerInstance();
  return (
    <OverlayContent
      icon={<HexIcon variant="check" icon={<Icons.Question />} />}
      title={title}
      body={body}
      actions={
        <Stack direction="row" gap={16}>
          <Button
            variant="secondary"
            onClick={onLeave || (() => close())}
            testId="leave-btn"
          >
            Leave
          </Button>
          <Button
            onClick={
              onContinue ||
              (() => {
                destroyOverlay();
                setShouldRenderGuard(false);
              })
            }
            testId="continue-btn"
          >
            {continueLabel}
          </Button>
        </Stack>
      }
      testId="exit-confirmation-overlay"
    />
  );
};
